
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("ikHKX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $d58c09618fe61e7f$var$_jquery = $d58c09618fe61e7f$var$_interopRequireDefault((parcelRequire("eQYlV")));
function $d58c09618fe61e7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $d58c09618fe61e7f$var$init = module.exports.init = function init() {
    var $btnOpenSearch = (0, $d58c09618fe61e7f$var$_jquery["default"])(".btn--search.btn--header");
    $btnOpenSearch.click(function(e) {
        e.preventDefault();
        (0, $d58c09618fe61e7f$var$_jquery["default"])("body").addClass("search-open");
    });
    var $btnCloseSearch = (0, $d58c09618fe61e7f$var$_jquery["default"])(".search-close");
    $btnCloseSearch.click(function(e) {
        e.preventDefault();
        (0, $d58c09618fe61e7f$var$_jquery["default"])("body").removeClass("search-open");
    });
    var body = document.querySelector("body");
    document.addEventListener("click", function(e) {
        if (body.classList.contains("search-open") && e.target.closest("#search") == null && e.target.closest(".btn--search") == null || e.target.classList.contains("search-close")) (0, $d58c09618fe61e7f$var$_jquery["default"])("body").removeClass("search-open");
    });
};

});


//# sourceMappingURL=flyoutSearch.module.179a724f.js.map
